module.exports = __webpack_public_path__ + "img/image3.19e56190.png";